import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import { PlantListInitialState, PlantListLoad } from './plant-list.actions';
import { LIST_SERVER_PAGINATION_INITIAL_STATE } from '../../../../../common/models/list.model';
import { CustomHttpErrorResponse, Error } from '../../../../../common/constants/error';
import { ListServerPaginationStateModel, NotificationService } from '../../../../../common';
import { catchError, map, take } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { PlantListService } from './plant-list.service';
import { PlantBrief } from '../models';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export type PlantListStateModel = ListServerPaginationStateModel<PlantBrief>;

const initialState: PlantListStateModel = LIST_SERVER_PAGINATION_INITIAL_STATE;

@State<PlantListStateModel>({
  name: 'plantList',
  defaults: initialState,
})
@Injectable()
export class PlantListState {
  constructor(public plantListService: PlantListService, private notificationService: NotificationService) {}

  @Selector()
  static getState(state: PlantListStateModel): PlantListStateModel {
    return state;
  }
  @Selector()
  static getLoaded(state: PlantListStateModel): boolean {
    return state.loaded;
  }

  @Action(PlantListLoad)
  getPlants(
    ctx: StateContext<PlantListStateModel>,
    { payload }: PlantListLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.plantListService.getPlantList(payload).pipe(
      take(1),
      map((plantList: PlantBrief[]) => {
        ctx.patchState({ ...plantList, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(PlantListInitialState)
  setInitialState(ctx: StateContext<PlantListStateModel>): void {
    ctx.setState(initialState);
  }
}
